import gql from 'graphql-tag';

export const registerWithdralCourses = gql`
  mutation registerWithdrawalCourses(
    $procedureId: Float!
    $coursesWithdrawal: [CourseWithdrawalInput!]!
  ) {
    registerWithdrawalCourses(
      request: {
        procedureId: $procedureId
        coursesWithdrawal: $coursesWithdrawal
      }
    ) {
      error
      requestId
    }
  }
`;

export const activateWithdrawalCourses = gql`
  mutation activateWithdrawalCourses($requestId: Float!) {
    activateWithdrawalCourses(requestId: $requestId) {
      error
      requestId
    }
  }
`;
